module.exports = __webpack_public_path__ + "img/8-Family_On_Motorbike.cb0f4c5.png";